import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/landing';
export function BonusSection() {
  return <section className="bg-ink px-5 py-20" data-id="element-1" data-mp="1of2ea2x0qe9o">
      <div className="mx-auto max-w-5xl" data-id="element-2" data-mp="22fmwawv40624">
        <div className="text-center" data-id="element-3" data-mp="22elm0ulx3nlg">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-gold" data-id="element-4" data-mp="22dit6h51bb2w">
            <GiftIcon className="h-4 w-4" data-id="element-5" data-mp="1aogso6g6jq83" /> Also included at no extra cost
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-6" data-mp="1amcnll6jol68">
            Five strategic <span className="text-gold" data-id="element-7" data-mp="1jgisq3mc74hu">bonuses</span>
          </h2>
          <p className="mt-4 text-sm font-medium text-slate-300" data-id="element-8" data-mp="1jivj9565un6i">
            Real value: $400 — today included FREE with Tennis Ready™.
          </p>
        </div>
        <div className="mt-11 grid gap-4 sm:grid-cols-2" data-id="element-9" data-mp="qz5bxv4sdtvu">
          {bonuses.map(({
          title,
          value,
          description,
          image
        }, index) => <article key={title} className={`overflow-hidden border border-gold/20 bg-ink-mid ${index === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:max-w-[calc(50%-0.5rem)]' : ''}`} data-id="element-10" data-mp="mws676q1hvz2" data-mpi={index}>
              <div className="aspect-square overflow-hidden bg-ink-deep" data-id="element-11" data-mp="2jhctss7hj3y8">
                <img src={image} alt={`${title} bonus cover`} loading="lazy" width={1024} height={1024} className="h-full w-full object-cover" data-id="element-12" data-mp="2jk8ugoapw6qd" />
              </div>
              <div className="p-6" data-id="element-13" data-mp="1vuehm6qeei64">
                <div className="flex flex-wrap items-center gap-2" data-id="element-14" data-mp="20qvhfy6ymkz1">
                  <p className="text-xs font-bold uppercase tracking-widest text-gold" data-id="element-15" data-mp="20trezlewb7my">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </p>
                  <span className="border border-gold/40 px-2 py-1 text-[10px] font-bold uppercase text-gold-light" data-id="element-16" data-mp="3c61wgvo6vhc3">
                    {value} — Free today
                  </span>
                </div>
                <h3 className="mt-3 text-lg font-bold text-white" data-id="element-17" data-mp="1h1kf649q34ye">{title}</h3>
                <p className="mt-2 text-sm font-medium leading-relaxed text-slate-300" data-id="element-18" data-mp="1c3ivpi8dx3me">
                  {description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}